import * as Yup from 'yup';

Yup.setLocale({
    mixed: {
        default: 'Neplatná hodnota',
        required: 'Povinné pole',
        notType: ({ type }) => {
            if (type === 'number') return 'Zadejte číslo';
            if (type === 'date') return 'Zadejte datum';
            return 'Neplatná hodnota';
        },
    },
    string: {
        email: 'Zadejte platný email',
        min: ({ min }) => `Minimálně ${min} znaků`,
        max: ({ max }) => `Maximálně ${max} znaků`,
        length: ({ length }) => `Musí mít přesně ${length} znaků`,
        matches: 'Neplatný formát',
    },
    number: {
        min: ({ min }) => `Minimálně ${min}`,
        max: ({ max }) => `Maximálně ${max}`,
    },
    date: {
        min: 'Datum je příliš brzy',
        max: 'Datum je příliš pozdě',
    },
});
